module.exports = require("@neuralegion/os-service");